/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Output_DeviceInputs */



/**
* | output |
* | --- |
* | "Output Device" |
*
* @param {Options_Adr_Output_DeviceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_output_device = /** @type {((inputs?: Options_Adr_Output_DeviceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Output_DeviceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Périphérique de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabegerät")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dispositivo di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выходное устройство")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dispositivo de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出设备")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力デバイス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट डिवाइस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dispositivo de saída")
	return /** @type {LocalizedString} */ ("Output Device")
});